import { PageController } from '@client/components/_core/layout/PageController';
import { AnalysisResults } from '@client/components/tools/document-analyzer/AnalysisResults';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/console/$orgId/tools/document-analyzer/history/$id/results')({
    staticData: {
        breadcrumb: {
            title: 'Analysis results',
        },
        ui: {
            title: 'Analysis results',
        },
        presentation: 'fullPage',
    },
    parseParams: (params) => ({
        id: z
            .string()
            .transform((val) => BigInt(val))
            .parse(params.id),
    }),
    component: ResultsPage,
});

function ResultsPage() {
    const { id } = Route.useParams();

    return (
        <PageController route={Route}>
            <AnalysisResults documentAnalysisId={id} />
        </PageController>
    );
}
